import React, { useEffect, useState } from 'react'
import ChartApi from '../../charts/chart.api'
import { SALESVERTICAL } from '../../util/constants'

export default function FiltersAndSearchBarDashboard({ entList , results , entityFinance , setEntityFinance , setChartSelectedEntities  , setEntList}) {
    const [entListDrop,setEntListDrop] = useState([])
    // const [results, setResults] = useState({})
    //     const [entityFinance, setEntityFinance] = useState("ALL")
    //     const [chartSelectedEntities, setChartSelectedEntities] = useState([])


    // useEffect(() => {
    //     ChartApi.getFinanceData(setResults, entityFinance)
    // }, [entityFinance])
    // useEffect(() => {
    //     setEntList(results?.entityList)
    //     let entityIds = []
    //     if (entityFinance === "ALL") {
    //         entityIds = results?.entityList?.filter(e => e.erpnumber && e.entityId)?.map(e => e.entityId) || []
    //         setChartSelectedEntities(entityIds)
    //     }
    // }, [results])
    useEffect(()=> {
        setEntListDrop(entList)
    },[entList])
  
    // console.log('mkmkmkmkmkmk',{entList , results , entityFinance , setEntityFinance , setChartSelectedEntities })

    const setFinanceCustomer = (value) => {
        let entityIds = []
        let customerCode = value.includes('/') ? value.split('/')[0] : value
        if (customerCode === "ALL") {
            entityIds = entList?.filter(e => e.erpnumber && e.entityId)?.map(e => e.entityId) || []
        } else {
            const selectedEntity = entList?.find(e => e.erpnumber === customerCode)
            if (selectedEntity?.entityId) {
                entityIds = [selectedEntity.entityId] 
            }
        }
    
        setChartSelectedEntities(entityIds)
        setEntityFinance(value)
    }

    const filterEntities = async (r) => {
     if(r !== 'ALL' && r ===  CATEGORIES.MSME ){
        let newEntityList =await entList.filter((x) => x.customer.crossBorder.salesVertical === r)
        setEntListDrop(newEntityList)
        setEntityFinance('ALL')
     }else  if(r !== 'ALL' && r ===  CATEGORIES.ENTERPRISE ){
        let newEntityList =await entList.filter((x) => x.customer.crossBorder.salesVertical !== CATEGORIES.MSME)
        setEntListDrop(newEntityList)
          setEntityFinance('ALL')
     }else if (r === 'ALL'){
        setEntListDrop(entList)
     } 
    }

    const CATEGORIES = {
        MSME: `MSME`,
        ENTERPRISE: `Enterprise`,
    }

  return (
    <div className='is-flex' style={{ backgroundColor : "white" , borderRadius : "5px" ,  padding : "1% 2%" , marginBottom : "1%"}}>
    <div style={{ width: '25%'}} >
              <p
                  className="label is-small figtree-text"
                  style={{ marginBottom: "0px" , fontWeight: '400' }}>
                  Entity Category
              </p>  
              <select name="status" id="status" style={{ padding : "1% 3%" , height : '35px', width :"95%" , fontWeight: '400' , border : '1px solid #BABABA' , borderRadius : '5px'   }}
                  onChange={(e) => filterEntities(e.target.value )}
              >
                  <option value="ALL">ALL</option>
                  {
                      Object.values(CATEGORIES)?.map((r,i) => {
                          return <option value={r}>{r}</option>
                      })
                  }

              </select> 

    </div>
    <div style={{ width: '25%'}} >
              <p
                  className="label is-small figtree-text"
                  style={{ marginBottom: "0px" ,  fontWeight: '400' }}>
                  Select Customer
              </p> 
              <select name="status" id="status" style={{padding : "1% 3%" , height : '35px' ,  width :"95%", fontWeight: '400' ,  border : '1px solid #BABABA' , borderRadius : '5px' }}
                  value={entityFinance} onChange={(e) => setFinanceCustomer(e.target.value ? e.target.value : "")}
              >
                  <option value="ALL">ALL</option>
                  {
                    entListDrop?.map(e => {
                          return <option value={e?.erpnumber + '/' + e.entityName}>{e.entityName}</option>
                      })
                  }

              </select> 
    </div>

      
    </div>
  )
}


